// routes.js


// Layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Accounts from "layouts/accounts";
import Logs from "layouts/logs";
import AccountDetails from "layouts/account-details";
import AlertHistory from "layouts/alert-history";
import ProtectedRoute from "protected_routes"
// MUI icon
import Icon from "@mui/material/Icon";
import Confirmation from "layouts/authentication/confirmation";
import SetNewPassword from "layouts/authentication/set-new-password";
import ResetPassword from "layouts/authentication/reset-password";
// Control visibility
const disableBilling = true;
const disableNotifications = true;
const disableTables = true;

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute><Dashboard /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: disableTables ? null : <ProtectedRoute><Tables /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: disableBilling ? null : <ProtectedRoute><Billing /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: disableNotifications ? null : <ProtectedRoute><Notifications /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <ProtectedRoute><Profile /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Accounts",
    key: "accounts",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/accounts",
    component: <ProtectedRoute><Accounts /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Logs",
    key: "logs",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/logs",
    component: <ProtectedRoute><Logs /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Alert History",
    key: "alert-history",
    icon: <Icon fontSize="small">notifications_active</Icon>,
    route: "/alert-history",
    component: <ProtectedRoute><AlertHistory /></ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "route",
    name: "Confirmation",
    key: "confirmation",
    icon: <Icon fontSize="small">verified</Icon>,
    route: "/authentication/confirmation",
    component: <Confirmation />, // Placeholder, actual component will be handled in the confirmation layout
  },
  {
    type: "route",
    name: "Account Details",
    key: "account-details",
    route: "/account-details/:accountName",
    component: <ProtectedRoute><AccountDetails /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Set New Password",
    key: "set-new-password",
    route: "/authentication/set-new-password",
    component: <SetNewPassword />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Reset Password",
    key: "reset-password",
    route: "/authentication/reset-password",
    component: < ResetPassword />,
    noCollapse: true,
  }
  
];

export default routes;
